import {
  routePaths,
  WorkspaceViewWithStats,
} from "@specsheet-common/shared-types";
import React from "react";
import { useAuth } from "src/hooks/contexts/useAuth";
import { useLocationState } from "src/hooks/utils/useLocationState";
import { useQueryWorkspaces } from "src/service/queryHooks/workspaces/queries/useQueryWorkspaces";
import { WorkspaceTile } from "./WorkspaceTile";
import { useQueryOrgUsers } from "src/service/queryHooks/users/queries/useQueryOrgUsers";

interface MenuButtonProps {
  expanded: boolean;
}

export const WorkspaceList = ({ expanded }: MenuButtonProps) => {
  let activeWorkspacesPerUser;
  const { organisation, profile } = useAuth();
  const { changeWorkspace } = useLocationState();
  const organisationId = organisation.id;

  const query = useQueryWorkspaces({
    organisationId,
    includeArchived: false,
    calculateStats: false,
    options: {
      staleTime: Number.POSITIVE_INFINITY,
    },
  });
  const workspaces = query.data || [];

  const queryUser = useQueryOrgUsers(organisation.id);
  const users = React.useMemo(() => queryUser.data || [], [queryUser.data]);

  const queryLoggedUser = users.find(
    (user) => user.userProfile.userId === profile.userId
  );

  if (queryLoggedUser?.organisationAccess.role === "ADMIN") {
    activeWorkspacesPerUser = workspaces;
  } else {
    activeWorkspacesPerUser = workspaces.filter((active) =>
      queryLoggedUser?.workspacesAccess.some(
        (access) => access.id === active.workspaceAccess.workspace.workspaceId
      )
    );
  }

  const handleNavToWorkspaceSettings = (ws: WorkspaceViewWithStats) => {
    changeWorkspace(
      routePaths.workspaceCampaigns,
      ws.workspaceAccess.workspace.workspaceId
    );
  };

  const handleNewCampaignInWorkspace = (
    e: React.MouseEvent,
    ws: WorkspaceViewWithStats
  ) => {
    changeWorkspace(
      routePaths.campaignCreate,
      ws.workspaceAccess.workspace.workspaceId
    );
    e.stopPropagation();
  };

  return (
    <>
      {activeWorkspacesPerUser.map((workspace: WorkspaceViewWithStats, i) => {
        return (
          <WorkspaceTile
            key={i}
            expanded={expanded}
            workspace={workspace}
            onClick={() => handleNavToWorkspaceSettings(workspace)}
            onIconClick={handleNewCampaignInWorkspace}
          />
        );
      })}
    </>
  );
};
